<template>
  <div class="d-flex align-center" style="gap: 8px">
    <v-menu offset-y rounded="lg">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text outlined> Capture Status <v-icon right> mdi-chevron-down</v-icon></v-btn>
      </template>
      <v-list class="px-2">
        <v-checkbox
          @change="changeSelect"
          v-model="checkPaymentStatus"
          value="paid"
          label="Paid"
          class="mt-0"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkPaymentStatus"
          value="canceled"
          label="Canceled"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkPaymentStatus"
          value="refunded"
          label="Refunded"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkPaymentStatus"
          value="partially_refunded"
          label="Partially Refunded"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkPaymentStatus"
          value="disputed"
          label="Disputed"
          hide-details="auto"
          class="mb-2"
        ></v-checkbox>
      </v-list>
    </v-menu>
    <v-menu offset-y rounded="lg">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text outlined> Fulfillment Status <v-icon right> mdi-chevron-down</v-icon></v-btn>
      </template>
      <v-list class="px-2">
        <v-checkbox
          @change="changeSelect"
          v-model="checkFulfillStatus"
          value="unfulfilled"
          label="Unfulfilled"
          class="mt-0"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkFulfillStatus"
          value="partially_unfulfilled"
          label="Partially Unfulfilled"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkFulfillStatus"
          value="fulfilled"
          label="Fulfilled"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkFulfillStatus"
          value="processing"
          label="Processing"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkFulfillStatus"
          value="partially_processing"
          label="Partially Processing"
          hide-details="auto"
        ></v-checkbox>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkPaymentStatus: [],
      checkFulfillStatus: [],
      fulfill: false,
      payment: false,
    };
  },
  mounted() {
    if (this.$route.query.paymentStatus) {
      this.checkPaymentStatus = this.$route.query.paymentStatus.split(',');
    }
    if (this.$route.query.fulfillStatus) {
      this.checkFulfillmentStatus = this.$route.query.fulfillmentStatus.split(',');
    }
  },
  methods: {
    // method của select
    changeSelect() {
      let data = {};
      if (this.checkPaymentStatus.length > 0) {
        data.paymentStatus = this.checkPaymentStatus.join();
      }
      if (this.checkFulfillStatus.length > 0) {
        data.fulfillmentStatus = this.checkFulfillStatus.join();
      }
      this.$emit('getSelect', data);
    },
  },
};
</script>
